import React from 'react';

import './PlainTextField.css';

const Field = ({ className, variant, ...props }) => {
  let cn = '';
  if (className) {
    cn += ` ${className}`;
  }
  if (variant) {
    cn += ` variant-${variant}`;
  }
  return <input className={`Plain-text-field${cn}`} {...props} />;
};

export default Field;



// WEBPACK FOOTER //
// ./src/components/basic/PlainTextField.js